import PropTypes from 'prop-types'
import { Button,  } from 'antd'
import { WarningFilled } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '../Common'
import { useCurrentUserRole } from '../../redux/slices/session'
import CycleLabel from './CycleLabel'

export default function ReportPatientHeader({
  showIssuesForm = false,
  backPath = '',
  onShowIssuesForm = () => {},
  cycleId = '',
  onPatientClick = null,
  isPatientDrawerVisible = false,
}) {
  const navigate = useNavigate()

  const userRole = useCurrentUserRole()
  const isClinician = userRole === 'clinician'

  const title = `${isClinician ? 'Generate' : 'Update'} BioBridge Report`

  return (
    <PageHeader
      title={title}
      onBack={!isClinician && backPath && (() => navigate(-1))}
      extra={
        <>
          {cycleId && <CycleLabel cycleId={cycleId} />}
          {/* Only pages that actually have a patient panel to reveal get the toggle. */}
          {onPatientClick && (
            <Button onClick={onPatientClick}>{isPatientDrawerVisible ? 'Hide' : 'Show'} Patient</Button>
          )}
          {showIssuesForm && (
            <Button onClick={onShowIssuesForm} icon={<WarningFilled />} shape="round">
              Report parsing issues
            </Button>
          )}
        </>
      }
    />
  )
}

ReportPatientHeader.propTypes = {
  backPath: PropTypes.string,
  onShowIssuesForm: PropTypes.func,
  showIssuesForm: PropTypes.bool,
  cycleId: PropTypes.string,
  onPatientClick: PropTypes.func,
  isPatientDrawerVisible: PropTypes.bool,
}
